export { getFacebookVanity } from './getFacebookVanity';
export { getFacebookAppId } from './getFacebookAppId';
export { getFacebookNamespace } from './getFacebookNamespace';
export { getFacebookLocale, getLocaleFromFacebookLocale } from './getFacebookLocale';
